// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const DotGrid2x3_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M6.75 8.625A1.125 1.125 0 1 1 5.625 7.5 1.125 1.125 0 0 1 6.75 8.625ZM12 7.5a1.125 1.125 0 1 0 1.125 1.125A1.125 1.125 0 0 0 12 7.5Zm6.375 2.25a1.125 1.125 0 1 0-1.125-1.125 1.125 1.125 0 0 0 1.125 1.125Zm-12.75 4.5a1.125 1.125 0 1 0 1.125 1.125 1.125 1.125 0 0 0-1.125-1.125Zm6.375 0a1.125 1.125 0 1 0 1.125 1.125A1.125 1.125 0 0 0 12 14.25Zm6.375 0a1.125 1.125 0 1 0 1.125 1.125 1.125 1.125 0 0 0-1.125-1.125Z',
  viewBox: '0 0 24 24',
  glyph: 'DotGrid2x3_Stroke2_Corner0_Rounded',
})

export const DotGrid3x1_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M13.125 12A1.125 1.125 0 1 1 12 10.875 1.125 1.125 0 0 1 13.125 12Zm5.25-1.125A1.125 1.125 0 1 0 19.5 12a1.125 1.125 0 0 0-1.125-1.125Zm-12.75 0A1.125 1.125 0 1 0 6.75 12a1.125 1.125 0 0 0-1.125-1.125Z',
  viewBox: '0 0 24 24',
  glyph: 'DotGrid3x1_Stroke2_Corner0_Rounded',
})
